import { useState } from 'react';
import DemoModal from '../../../components/feature/DemoModal';

const highlights = [
  { icon: 'ri-shield-check-line', label: 'Enterprise-Grade Security' },
  { icon: 'ri-customer-service-2-line', label: 'Dedicated Support Team' },
  { icon: 'ri-settings-4-line', label: 'Custom Integrations' },
  { icon: 'ri-bar-chart-grouped-line', label: 'Tailored Analytics' },
];

export default function Pricing() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  return (
    <>
      <section id="pricing" className="py-28 bg-gray-950 relative overflow-hidden">
        {/* Background glow */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-teal-500/5 rounded-full blur-3xl" />
        </div>

        <div className="container mx-auto px-6 relative z-10">
          {/* Header */}
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 bg-teal-500/10 border border-teal-500/30 text-teal-400 text-sm font-medium rounded-full mb-5 tracking-wide uppercase">
              Pricing
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
              Built Around <span className="text-teal-400">Your Needs</span>
            </h2>
            <p className="text-lg text-gray-400 max-w-xl mx-auto leading-relaxed">
              Every organization is different. Talk to our team and get a solution tailored specifically to your goals, scale, and budget.
            </p>
          </div>

          {/* Main Card */}
          <div className="max-w-5xl mx-auto">
            <div className="rounded-2xl border border-gray-800 bg-gray-900/60 backdrop-blur-sm overflow-hidden">
              <div className="grid md:grid-cols-2">
                {/* Left: highlights */}
                <div className="p-10 border-b md:border-b-0 md:border-r border-gray-800 flex flex-col justify-center">
                  <h3 className="text-2xl font-bold text-white mb-3">What's included</h3>
                  <p className="text-gray-400 text-sm mb-8 leading-relaxed">
                    Our team works with you to design a plan that fits your exact requirements — no unnecessary extras, no hidden costs.
                  </p>
                  <ul className="space-y-5">
                    {highlights.map((item, i) => (
                      <li key={i} className="flex items-center gap-4">
                        <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-teal-500/10 border border-teal-500/20 shrink-0">
                          <i className={`${item.icon} text-teal-400 text-lg`}></i>
                        </div>
                        <span className="text-gray-200 text-sm font-medium">{item.label}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Right: CTA */}
                <div className="p-10 flex flex-col justify-center">
                  <div className="mb-8">
                    <div className="flex items-center gap-2 mb-4">
                      <span className="w-2 h-2 rounded-full bg-teal-400 animate-pulse"></span>
                      <span className="text-teal-400 text-xs font-semibold uppercase tracking-widest">Sales Team Available</span>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-3">Let's find the right fit</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      Schedule a call with our experts. We'll walk you through the platform, understand your use case, and put together a custom proposal — usually within 24 hours.
                    </p>
                  </div>

                  <div className="space-y-3">
                    <button
                      onClick={() => setIsDemoModalOpen(true)}
                      className="w-full px-6 py-4 bg-teal-500 hover:bg-teal-400 text-gray-900 font-semibold rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm flex items-center justify-center gap-2"
                    >
                      <i className="ri-calendar-line text-base"></i>
                      Schedule a Call
                    </button>
                    <button
                      onClick={() => setIsDemoModalOpen(true)}
                      className="w-full px-6 py-4 bg-transparent border border-gray-700 hover:border-teal-500/50 text-gray-300 hover:text-white font-semibold rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm flex items-center justify-center gap-2"
                    >
                      <i className="ri-mail-send-line text-base"></i>
                      Send Us a Message
                    </button>
                  </div>

                  <p className="text-gray-600 text-xs text-center mt-5">
                    No commitment required &nbsp;·&nbsp; Response within 24h
                  </p>
                </div>
              </div>
            </div>

            {/* Bottom trust bar */}
            <div className="mt-8 flex flex-wrap items-center justify-center gap-8 text-gray-500 text-sm">
              <span className="flex items-center gap-2">
                <i className="ri-lock-line text-teal-500/60"></i> SOC 2 Compliant
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-global-line text-teal-500/60"></i> 99.9% Uptime SLA
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-team-line text-teal-500/60"></i> Dedicated Onboarding
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-refund-2-line text-teal-500/60"></i> 14-Day Free Trial
              </span>
            </div>
          </div>
        </div>
      </section>

      {isDemoModalOpen && (
        <DemoModal
          isOpen={isDemoModalOpen}
          onClose={() => setIsDemoModalOpen(false)}
        />
      )}
    </>
  );
}
